"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddEventFormPopup = exports.ScheduleTimeOffFormPopup = exports.EventTimeOffFormPopup = exports.EventTimeOffFormDefaultArgs = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var il_icon_common_1 = require("../il-icon/il-icon.common");
var solid_icon_definitions_1 = require("../il-icon/solid-icon-definitions");
var enums_1 = require("../../shared/enums");
var event_timeoff_form_1 = require("./event-timeoff.form");
exports.EventTimeOffFormDefaultArgs = {
    studentList: [
        {
            guid: 'all',
            firstName: 'All Students',
            avatar: 'black',
        },
        {
            guid: '1',
            firstName: 'Adam',
            avatar: 'RED',
        },
        {
            guid: '2',
            firstName: 'Jesse',
            avatar: 'PINK',
        },
    ],
    defaultFormValues: {
        students: ['1'],
    },
    onSubmit: console.log,
};
function EventTimeOffFormPopup(_a) {
    var _b = _a.open, open = _b === void 0 ? false : _b, onClose = _a.onClose, dialogProps = _a.dialogProps, props = __rest(_a, ["open", "onClose", "dialogProps"]);
    var theme = (0, material_1.useTheme)();
    var fullScreen = (0, material_1.useMediaQuery)(theme.breakpoints.down('md'));
    return (react_1.default.createElement(material_1.Dialog, __assign({ onClose: onClose, open: open, PaperProps: { sx: { backgroundColor: 'background.default' } }, fullScreen: fullScreen }, dialogProps),
        react_1.default.createElement(material_1.IconButton, { onClick: onClose, "data-testid": "close-icon", sx: {
                position: 'absolute',
                mt: '0.5rem',
                mr: '0.5rem',
                top: 0,
                right: 0,
            } },
            react_1.default.createElement(il_icon_common_1.SolidIcon, { icon: solid_icon_definitions_1.SolidIconDefinitions.X_MARK_ICON, size: enums_1.IconSizeEnum.SMALL })),
        react_1.default.createElement(event_timeoff_form_1.EventTimeOffForm, __assign({}, props))));
}
exports.EventTimeOffFormPopup = EventTimeOffFormPopup;
function ScheduleTimeOffFormPopup(props) {
    return react_1.default.createElement(EventTimeOffFormPopup, __assign({ open: true }, props));
}
exports.ScheduleTimeOffFormPopup = ScheduleTimeOffFormPopup;
function AddEventFormPopup(props) {
    return react_1.default.createElement(EventTimeOffFormPopup, __assign({ open: true, showEventForm: true }, props));
}
exports.AddEventFormPopup = AddEventFormPopup;
